import { render, staticRenderFns } from "./app.vue?vue&type=template&id=5a469f7d&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlobalsLayoutLoader: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/_globals/layout/Loader.vue').default,GlobalsLayoutErrors: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/_globals/layout/Errors.vue').default})
